<script>
import { BaseAnimation } from '~/mixins/BaseAnimation'

export default {
  name: 'BaseAnimation',
  mixins: [BaseAnimation],
  props: {
    offset: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 0.75
    },
    attr: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    animTween() {
      TweenMax.to(this.$el, this.duration, this.attr)
    },
    animation() {
      const config = {
        rootMargin: `${this.offset}px 0px 0px 0px`,
        threshold: 0.5
      }

      this.observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          this.observer.unobserve(entries[0].target)
          this.animTween()
        }
      }, config)

      if (this.$el) {
        this.observer.observe(this.$el)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// components/_UI/BaseAnimation.vue